const phoneIcon = 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5f6354390e7632002ddfd125/images/1632493866233-phone.jpg'
const homephoneIcon = 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5f6354390e7632002ddfd125/images/1632493866233-phone.jpg'
const mailIcon = 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5f6354390e7632002ddfd125/images/1632494224680-email.jpg'
const wwwIcon = 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5f6354390e7632002ddfd125/images/1632493793515-website.jpg'
const placemarkIcon = 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5f6354390e7632002ddfd125/images/1632494240498-address.jpg'
const skypeIcon = 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5f6354390e7632002ddfd125/images/1632493734108-skype.jpg'

const socialsIcons = [
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5f6354390e7632002ddfd125/images/1632493948944-facebook.png',
    link: 'https://www.facebook.com/uaeconsulting/',
    mediaType: 'facebook',
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5e0b06b1f3d72e001183707a/images/1632562040349-vk.png',
    link: '',
    mediaType: 'vkontakte'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5f6354390e7632002ddfd125/images/1632493848831-youtube.png',
    link: 'https://www.youtube.com/channel/UCoT9JgJZMMvnIvZM-84LmaQ?sub_confirmation=1',
    mediaType: 'youTube'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5f6354390e7632002ddfd125/images/1632493920319-instagram.png',
    link: 'https://www.instagram.com/uaeconsulting/',
    mediaType: 'instagram'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5f6354390e7632002ddfd125/images/1632493773065-twitter.png',
    link: 'https://twitter.com/UaeConsulting',
    mediaType: 'twitter'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5f6354390e7632002ddfd125/images/1632493808703-telegram.png',
    link: 'https://t.me/uae_consulting',
    mediaType: 'telegram'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5f6354390e7632002ddfd125/images/1632493896275-linkedin.png',
    link: 'https://www.linkedin.com/company/uae-consulting-com/',
    mediaType: 'linkedIn'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5e0b06b1f3d72e001183707a/images/1632563082337-rss.png',
    link: 'https://www.uae-consulting.com/rss/',
    mediaType: 'rss'
  },
  {
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5e0b06b1f3d72e001183707a/images/1632562794265-igtv.png',
    link: 'https://www.instagram.com/uaeconsulting/',
    mediaType: 'igtv'
  }
]

export {
  phoneIcon,
  homephoneIcon,
  mailIcon,
  wwwIcon,
  placemarkIcon,
  skypeIcon,
  socialsIcons
}



// WEBPACK FOOTER //
// ./src/constants/signatureGmail/svgIconsSignatureType2.js